module.exports = __webpack_public_path__ + "img/Tuberia para cercas.20f2ff31.jpg";